<template class="template-page" >
    <div class="container mb-5" >
        <div class="col-12 col-sm-12 col-md-6 offset-md-3 mb-5" >
            <div class="row" >
                <div class="col-12 text-center" >
                   <a href="https://brilly.io" > <img src="@/assets/logo.png" height="80" class="mt-5" /> </a>
                </div>    
            </div>
            
                <div class="col-12 col-md-8 offset-md-2 mt-5" >
                    
                    <button 
                        type="button" 
                        class="btn btn-primary btn-facebook" 
                        @click="fblogin"
                        v-if="!isConnected"
                    >
                        <span><font-awesome-icon :icon="['fab', 'facebook']" /></span> 
                        Log in With Facebook
                    </button>

                    <button 
                        type="button" 
                        class="btn btn-primary btn-facebook" 
                        @click="fblogin"
                        v-if="isConnected"
                    >
                        <span> <img :src="profilePicture" /> </span> 
                        Continue as {{fname}}
                    </button>

                    <button 
                        type="button" 
                        class="btn btn-secondary btn-facebook mt-3" 
                        @click="fblogout"
                        v-if="isConnected"
                    >
                        <span> <img :src="profilePicture" /> </span> 
                        Not {{fname}}? Logout
                    </button>
                    
                </div>
                
                <div class="col-12 text-center mt-5" >
                    <h5> - or - </h5>
                </div>
                
                <div class="col-12 mt-5" >
                    <b-form  @submit.prevent="onSubmit" id="register-form"  v-if="show">
                        
                        <b-form-group id="emailGroup" >
                            <label>Email:</label>
                            <b-form-input id="emailInput" 
                            type="email"
                            @change="checkEmail"
                            v-model.lazy="$v.form.email.$model"
                            :state="validateState('email')"
                            aria-describedby="input-1-live-feedback"
                            placeholder="Email">
                            </b-form-input>
                            
                            <b-form-invalid-feedback id="input-1-live-feedback" >                       
                                This is a required field and needs to be an email
                            </b-form-invalid-feedback>
                            <div class="invalid" v-if="emailExists" > Email already exists </div>
                        </b-form-group>
                        
                        
                        <b-form-group id="usernameGroup" >
                            <label>Username:</label>
                            <b-form-input id="usernameInput" 
                            type="text"
                            @change="checkUserame"
                            v-model="$v.form.username.$model"
                            :state="validateState('username')"
                            aria-describedby="input-2-live-feedback"
                            placeholder="Username">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-2-live-feedback" >                       
                                This must be at least 3 characters can only contain alphanumerics ( a-z, 0-9 )
                            </b-form-invalid-feedback>
                            <div class="invalid info" v-if="usernameExists" > {{ usernameExists }} </div>
                        </b-form-group>
                        
                        <b-form-group id="fnameGroup"  >
                            <label>Firstname:</label>
                            <b-form-input id="fnameInput" 
                            type="text"
                            v-model="form.fname"
                            :state="validateState('fname')"
                            aria-describedby="input-3-live-feedback"
                            placeholder="Firstname">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-3-live-feedback" >                       
                                This is a required field and must be at least 3 characters.
                            </b-form-invalid-feedback>
                        </b-form-group>
                        
                        <b-form-group id="lnameGroup" >
                            <label>Lastname:</label>
                            <b-form-input id="lnameInput"
                            type="text"
                            v-model="form.lname"
                            :state="validateState('lname')"
                            aria-describedby="input-4-live-feedback"
                            placeholder="Lastname">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-4-live-feedback" >                       
                                This is a required field and must be at least 3 characters.
                            </b-form-invalid-feedback>
                        </b-form-group>
                        
                        <b-form-group id="organizationGroup" >
                            <label>Organization:</label>
                            <b-form-input id="organizationInput"
                            type="text"
                            v-model="form.organization"
                            placeholder="Organization">
                            </b-form-input>
                        </b-form-group>

                         <b-form-group id="passwordGroup" >
                            <label>Password:</label>
                            <b-form-input id="passwordInput" 
                            type="password"
                            v-model="form.password"
                            :state="validateState('password')"
                            aria-describedby="input-6-live-feedback"
                            placeholder="Password">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-6-live-feedback" >                       
                                This is a required field and must be at least 6 characters.
                            </b-form-invalid-feedback>
                        </b-form-group>

                         <b-form-group id="repasswordGroup" >
                            <label>Enter password again:</label>
                            <b-form-input id="repasswordInput" 
                            type="password"
                            v-model="form.repassword"
                            :state="validateState('repassword')"
                            aria-describedby="input-7-live-feedback"
                            placeholder="Password">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-7-live-feedback" >                       
                                This is a required field and must be the same as the password above.
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <div class="row mt-4 pt-2" >
                            <div class="col-12 col-md-8 offset-md-2" > <b-button type="submit" variant="primary" > Create account </b-button> </div>
                        </div>

                        <div class="row mt-5  text-center" >
                            <div class="col-12 " > Already have an account? </div>
                            <div class="col-12 col-md-8 offset-md-2 mt-3" > <router-link :to="{name: 'Login'}"  class="btn btn-secondary" > Log in </router-link>  </div>
                        </div>
                        
                    </b-form>
                    
                    <div id="response" class="col-12 text-center mt-5" v-if="response" > {{ response }} </div>
                    
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {AUTH_REQUEST,AUTH_CHECK } from '@/store/actions/auth'
import { mapGetters, mapState } from 'vuex'
import { validationMixin } from "vuelidate";
import { required, email, sameAs, minLength, alpha, alphaNum } from "vuelidate/lib/validators";    
    
export default {
    mixins: [validationMixin],
    name: "registerPage",
    data () {
        return {
            form: {
                email: null,
                username: null,
                fname: '',
                lname: '',
                organization: '',
                password: '',
                repassword: '',

            },
            show: true,
            response: false,
            emailExists: false,
            usernameExists: false,
            
            isConnected: false,
            fname: '',
            name: '',
            email: '',
            profilePicture: '',
        }
    },
    validations: {
        form: {
            email: {
                required,
                email,
                /*
                checkEmail: function ( email ) { 
                    
                    if (email === '') return true
                    
                    let data = JSON.stringify({
                            "email": email
                        } )

                    return axios({ method: 'POST', url: process.env.ROOT_API+'/account/exists_email.php', headers: { 'Content-Type': 'text/plain' }, data: data })
                    .then(resp => {

                        let r = resp.data;

                        return r.message


                    }); //end axios
                }
                */
            },
            username: {
                required,
                alphaNum,
                minLength: minLength(3)
            },
            fname: {
                required,
                alpha,
                minLength: minLength(3)
            },
            lname: {
                required,
                alpha,
                minLength: minLength(3)
            },
            password: {
                required,
                minLength: minLength(6)
            },
            repassword: {
                required,
                minLength: minLength(6),
                sameAs : sameAs( function(){return this.form.password} )
            },
        }
    },
    beforeCreate: function (){
        //location.reload();
    },
    created: function () {
        
    },
    methods: {
        validateState(username) {
          const { $dirty, $error } = this.$v.form[username];
          return $dirty ? !$error : null;
        },
        onSubmit() {
            
            this.$v.form.$touch();

            if (this.$v.form.$anyError) {
                return;
            }
        
            if( this.emailExists == false ){
                
                console.log( "submitted" )
                this.$Progress.start()
                let params = JSON.stringify(
                    {
                    "email":  this.form.email,
                    "username":  this.form.username,
                    "fname":  this.form.fname,
                    "lname":  this.form.lname,
                    "organization":  this.form.organization,
                    "password": this.form.password
                    }
                )

                params = encodeURIComponent(window.btoa(params))

                axios({ method: 'POST', url: process.env.ROOT_API+'/account/register.php', headers: { 'Content-Type': 'text/plain', }, data: params })
                .then(resp => {

                    let r = resp.data;

                    if( r.status == 100 ){

                        //this.response = "User has been created. Please verify your email in order to enable your account"
                        this.response = 'Account successfully set up. Please proceed to the login page to access your account';
                        
                        this.$router.push({ name: 'ThankYou'});

                    }else{

                         this.response = r.message

                    }
                    this.$Progress.finish()
                }) //end axios
                
            }
                
          
        }, //end onSubmit
        statusChangeCallback(response){
			if(response.status === 'connected'){
                this.isConnected = true
				console.log('Logged in and authenticated');
				//this.fetchData();
			} else {
                this.isConnected = false
				console.log('Not authenticated');
                //this.fblogin();
			}
		},
        checkUserame(){
            
            let username = this.form.username;
            
            if( username != '' ){
                            
                if( username.indexOf(' ') >= 0 ){
                    username = username.replace(/ /g, '');
                    this.form.username = username;

                }
                
                username = username.toLowerCase();
                this.form.username = username;

                let data = JSON.stringify({
                    "username":  this.form.username
                } )

                axios({ method: 'POST', url: process.env.ROOT_API+'/account/exists_username.php', headers: { 'Content-Type': 'text/plain' }, data: data })
                .then(resp => {

                    let r = resp.data;

                    if( r.status == 100 ){
                        
                        if( this.form.username != r.message ){
                            this.usernameExists = this.form.username+" is not available. We recommend "+ r.message
                            this.form.username = r.message
                        }
                        
                    }else{
                        this.usernameExists = true
                    }


                }); //end axios
            }else{
                this.usernameExists = false
            }
            
        }, //end checUsername
         checkEmail(){
            
            let email = this.form.email;
            if( email != '' ){
                
                if( email.indexOf(' ') >= 0 ){
                    email = email.replace(/ /g, '');
                    this.form.email = email;
                }

                let data = JSON.stringify({
                    "email":  this.form.email
                } )

                axios({ method: 'POST', url: process.env.ROOT_API+'/account/exists_email.php', headers: { 'Content-Type': 'text/plain' }, data: data })
                .then(resp => {

                    let r = resp.data;

                    if( r.status == 100 ){

                        //return true;
                        this.emailExists = false

                    }else{
                        this.emailExists = true
                    }


                }); //end axios
            }else{
                this.emailExists = false
            }

        }, //end checkEmail
        
        fblogin(){
            FB.login((response) => {
                console.log(response)
                if (response.status === 'connected') {
                    this.statusChangeCallback( response )
                    //fetchData
                    FB.api('/me?fields=id,first_name,last_name,email,picture.width(300).height(300) ', (response) => {
                        if(response && !response.error){
                            console.log(response);
                            this.profilePicture = response.picture.data.url
                            //console.log(this.profilePicture)
                            this.fname = response.first_name;
                            this.name = response.first_name + " " + response.last_name;
                            
                            let user = {
                                'email': response.email,
                                'fname': response.first_name,
                                'lname': response.last_name,
                                'FBID': response.ID,
                                'profilePicture': response.picture.data.url,
                                'type': 'facebook'
                            }

                            this.$store.dispatch(AUTH_REQUEST, user ).then(() => {
                                this.$router.push({ name: 'Home'});
                            })
                            
                            
                        }
                    })
                    
                            
                    // Logged into your webpage and Facebook.
                } else {
                    // The person is not logged into your webpage or we are unable to tell. 
                    this.isConnected = false
                }
            });
            
            console.log(this.name)
            
        },
        fblogout(){
            FB.logout( (response) => {
                
				console.log('Logged out');
                this.isConnected = false
                this.name = ''
                this.profilePicture = ''
                
            });
            
        },
        
    },
    computed: {
        
    }
}
</script>

<style lang="scss" scoped>
    body{
        border:none!important;
    }

    #register-form .form-group{
        color: #1a1a1a;
        background: transparent;
        margin: 20px 0 0 0;
    }
    #register-form .form-group:first-of-type{
        margin:0;
    }
    
    #register-form  label{
        //display: inline-block;
        margin-bottom: 0px!important
    }
    
    #register-form .btn{
        position:relative;
        
        margin-left: auto;
    }
    
    .invalid {
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545;
    }
    .invalid.info{
        color: #1a1a1a;
    }
    
    .v-facebook-login{
        margin: auto!important;
    }
    
    .btn{
        width: 100%;
        font-size: 1.1rem;
        font-weight: bold;
        padding: .6rem 1.5rem
    }
    .btn-facebook svg{
        margin-right: 10px;
        font-size: 23px;
    }
    .btn-facebook img{
        margin-right: 10px;
        width:23px;
        height:23px;
        border-radius: 50%;
    }
    
</style>


// WEBPACK FOOTER //
// src/templates/auth/CreateAccount.vue